import React, { Component } from 'react';
import { BrowserRouter,  Redirect,  Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import TwoStageForm from './pages/TwoStageForm';
import Shutdown from './pages/TwoStageForm/Shutdown';
import SaveAndRetrieve from './pages/SaveAndRetrieve/SaveAndRetrieve';
import UnSubscription from './pages/UnSubscription';
import CantApply from './pages/CantApply/CantApply';

export default class App extends Component {
    static displayName = App.name;
    
    render() {
        
        return (
            <Layout>
                <BrowserRouter>
                    <Route path="/TwoStageForm/:product/:offerCode?" component={TwoStageForm} />
                    <Route path="/Acquisition" component={Shutdown} />
                    <Route path="/CantApply" component={CantApply} />
                    <Route path="/check-fa/:id?" component={SaveAndRetrieve} />
                    <Route path="/unsubscription/:id?" component={UnSubscription} />
                    <Redirect from="/SingleForm/:product/:page?/:version?/:offerCode?" to={{ ...window.location, pathname: window.location.pathname.replace('/SingleForm/', '/TwoStageForm/') }} />
                </BrowserRouter>
            </Layout>
        );
    }
}
